module.exports = __webpack_public_path__ + "img/play.02ce6754.png";